export const API_STATUS = "API_STATUS";
export const GET_LIST = "GET_LIST";
export const CLEAR_API_STATUS = "CLEAR_API_STATUS";
export const GET_VALI_DATA = "GET_VALI_DATA";
export const SET_SELECTED_FILES = "SET_SELECTED_FILES";
export const PDF_AND_PAGE_DETAILS = "PDF_AND_PAGE_DETAILS";
export const VALIDATE_USER_STATUS = "VALIDATE_USER_STATUS";
export const IS_SIGNATURE_UPLOADED_STATUS = "  IS_SIGNATURE_UPLOADED_STATUS";
